import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliConssultancy = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #1e3a8a, #3b82f6)' }}>
        <div className="hero-content">
          <h1>AALI CONSSULTANCY</h1>
          <p>Your trusted partner for employment opportunities and education pathways — across India and beyond</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI CONSSULTANCY</h2>
              <p>AALI CONSSULTANCY is a leading employment and education consultancy serving clients across India and overseas. We connect job seekers with the right opportunities across all private sectors and domains, and guide students and professionals in making informed decisions about their education — from the right branch and domain to the best institution at the right cost.</p>
              <h3>Employment Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Private Sector Job Placements (India & Overseas)</div>
                <div className="service-item"><span>✔</span> Overseas Employment Assistance</div>
              </div>
              <h3 className="space-top">Education Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Management Quota Admissions</div>
                <div className="service-item"><span>✔</span> Fee Negotiation & Cost Optimisation</div>
                <div className="service-item"><span>✔</span> Study Abroad Guidance</div>
                <div className="service-item"><span>✔</span> Branch & Domain Selection Counselling</div>
                <div className="service-item"><span>✔</span> Admissions in India & International Institutions</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Consultancy</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <a href="https://aaliconssultancy.com/" className="btn-primary" target="_blank" rel="noopener noreferrer">
                  Visit Main Website
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliConssultancy;